import { Injectable } from '@angular/core';
import { STAGES } from '../constants/stages.constans';
import { AvailableStepGuard } from './available-step.guard';
import { MenuService } from '../services/menu.service';

@Injectable({
  providedIn: 'root'
})
export class CircleFinalAvailable extends AvailableStepGuard {

  step = STAGES.CIRCLE_FINAL;

}
